import { render, staticRenderFns } from "./cateHeadImg.vue?vue&type=template&id=25307c9d&scoped=true"
import script from "./cateHeadImg.vue?vue&type=script&lang=js"
export * from "./cateHeadImg.vue?vue&type=script&lang=js"
import style0 from "./cateHeadImg.vue?vue&type=style&index=0&id=25307c9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25307c9d",
  null
  
)

export default component.exports